export default function playSoundWithWebAudio(soundUrl, playCount, soundPlayTimeout, done) {
	let webAudioSound = null;
	
	try {
		const play = (times) => {
			webAudioSound = new Audio(soundUrl);

			webAudioSound.onplaying = () => {
				log('Audio in web audio mode playing from executor');
				clearTimeout(soundPlayTimeout);
			};

			webAudioSound.oncanplay = () => {
				console.log('Web Audio sound can play');
			};

			webAudioSound.onerror = (error) => {
				console.error('Web Audio sound error:', error);
			};

			if (times > 0) {
				webAudioSound.onended = () => {
					log('Audio in web audio mode from executor ended');
					times > 1 ? play(times - 1) : done?.();
				};
			}
			webAudioSound.play();
		};

		play(playCount);
	} catch (ex) {
		console.error('Error playing sound by Web Audio:', ex);
		Screen.logErrorToSentry(ex);
		done?.();
		return;
	}

	return () => {
		webAudioSound.onended = null; 
		webAudioSound.pause();
		done?.();
	};
}
